<script setup>
import { reactive, defineEmits, defineProps } from "vue";
import useEditUserModal from "@/scripts/Users/EditUserModal.js";

const emit = defineEmits(["closeEditModal"]);
const props = defineProps({
  user: Object,
  permissions: Array,
});
const { user, permissions } = reactive({ ...props });

const {
  loading,
  update_fullname,
  update_username,
  user_permissions,
  updateUser,
} = useEditUserModal(user);
</script>

<template>
  <div
    class="modal fade show"
    tabindex="-1"
    aria-modal="true"
    role="dialog"
    style="display: block"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Update User</h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="emit('closeEditModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Full Name</label>
            <input
              type="text"
              class="form-control"
              v-model="update_fullname"
              :placeholder="user.name ?? 'Enter Name'"
            />
          </div>
          <div class="form-group">
            <label>Username</label>
            <input
              type="text"
              class="form-control"
              v-model="update_username"
              :placeholder="user.email ?? 'Enter Username'"
            />
          </div>
          <div class="form-group">
            <div
              v-for="permission in permissions"
              :key="permission.id"
              class="form-check col-md-4 col-sm-6"
            >
              <input
                v-model="user_permissions"
                class="form-check-input"
                type="checkbox"
                :value="permission.permission"
                :id="permission.id"
              />
              <label class="form-check-label text-nowrap" :for="permission.id">
                {{ permission.name }}
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline pull-left btn-danger"
            @click="emit('closeEditModal')"
          >
            CLOSE
          </button>
          <button
            type="button"
            class="btn btn-primary fixed-width-button"
            :disabled="loading"
            @click="updateUser()"
          >
            <font-awesome-icon
              v-show="loading"
              :icon="['fas', 'spinner']"
              spin
            />
            <span v-show="!loading">UPDATE USER</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fixed-width-button {
  width: 140px;
}
</style>
